import { Clock } from "lucide-react";
import { money, fmtKST } from "@/lib/api";

const left = (b) => Math.max(0, Math.round((b.owed - b.paid - b.pending) * 100) / 100);
const soon = (b) => {
  const ms = new Date(b.payment_due) - Date.now();
  return !!b.payment_due && !b.past_due && left(b) > 0.005 && ms > 0 && ms <= 86400000;
};

export const DueSoonAlert = ({ dropBalances = [], specialBalances = [], onPay }) => {
  const items = [
    ...dropBalances.filter(soon).map((b) => ({ key: `d:${b.drop_id}`, name: b.title, ...b })),
    ...specialBalances.filter(soon).map((b) => ({ key: `s:${b.special_drop_id}`, ...b })),
  ];
  if (!items.length) return null;
  const payTo = items[0].pay_to;
  const total = items.reduce((s, b) => s + left(b), 0);
  return (
    <div data-testid="due-soon-alert" className="mt-6 rounded-2xl border border-amber-400/40 bg-amber-400/[0.07] p-4 sm:p-5 shadow-[0_0_24px_rgba(251,191,36,0.12)]">
      <div className="flex flex-wrap items-center gap-3">
        <span className="inline-flex items-center gap-2 font-display text-base font-bold text-amber-200">
          <Clock className="h-4 w-4" /> Payment due in less than 24 hours
        </span>
        <button type="button" data-testid="due-soon-pay-btn" onClick={() => onPay(items.filter((b) => b.pay_to === payTo).map((b) => b.key))}
          className="ml-auto rounded-full bg-amber-400 px-4 py-1.5 text-sm font-bold text-zinc-950 transition-colors hover:bg-amber-300">
          Pay now
        </button>
      </div>
      <p className="mt-2 text-sm text-amber-100/90">Pay before the due time to avoid $1/day late fees. Total {money(total)}.</p>
      <ul className="mt-2 space-y-1 text-xs" data-testid="due-soon-list">
        {items.map((b) => (
          <li key={b.key} data-testid={`due-soon-${b.key.slice(2)}`} className="flex flex-wrap gap-x-2 text-amber-200/90">
            <span className="font-semibold">{b.name}</span>
            <span className="font-mono">{money(left(b))}</span>
            <span className="text-amber-300/70">due {fmtKST(b.payment_due)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
